<div class="uk-text-center">
  <ng-container *ngIf="item?.dealflow_files?.length">
    <div class="uk-flex-inline uk-flex-middle uk-flex-center">
      <div [hidden]="index !== openFolder" class="triangle"></div>

      <fa-icon [style.width]="index !== openFolder ? 0 : 'auto'" icon="folder-open" class="pointer"></fa-icon>

      <fa-icon [style.width]="index === openFolder ? 0 : 'auto'" (click)="toggleFolderIcon(index)" icon="folder" class="pointer"> </fa-icon>

      <div
        class="drop-container card"
        uk-drop="mode: click; offset: 5; pos: bottom-right; animation: uk-animation-slide-left-small;"
        [id]="'drop-admin' + index">
        <div class="uk-card uk-card-default uk-flex uk-flex-column uk-text-left drop">
          <div *ngFor="let file of item.dealflow_files" class="file uk-flex">
            <fa-icon [icon]="['far', 'file']"></fa-icon>

            <span> {{ file.description | shortFileName }}</span>

            <app-download-file [url]="file.file"></app-download-file>

            <fa-icon (click)="deleteAdminFile(file.id)" [icon]="['far', 'trash-alt']" class="pointer"></fa-icon>
          </div>
        </div>
      </div>
    </div>

    <span class="margin-small-right"> / </span>
  </ng-container>

  <label [for]="'file' + item.id">
    <fa-icon icon="file-upload" class="pointer"></fa-icon>
  </label>

  <input (change)="uploadFile($event, item.id)" [id]="'file' + item.id" class="file-upload" type="file" />
</div>
